import { Formik } from 'formik';
import React from 'react';

import SendIcon from '@mui/icons-material/Send';
import { Box, Paper, IconButton } from '@mui/material';

import { ConnectedTextField } from '@libs/ui/components/form/text-field';

import { useSendSms } from '../hooks';
import { SmsConversationType } from '../types';

interface FormModel {
  message: string;
}

interface SmsChatInputProps {
  conversation: SmsConversationType;
}

const SmsChatInput: React.FC<SmsChatInputProps> = ({ conversation }) => {
  const { sendSms, loading } = useSendSms();

  return (
    <Formik<FormModel>
      initialValues={{ message: '' }}
      onSubmit={async (values, { resetForm }) => {
        if (!values.message.trim()) return;
        await sendSms(conversation.talent.id, values.message);
        resetForm();
      }}
    >
      {({ handleSubmit, isSubmitting, values }) => (
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <Box
            px={4}
            py={2}
            borderTop="1px solid #E0E0E0"
            display="flex"
            alignItems="center"
          >
            <Paper
              elevation={0}
              sx={{
                flex: 1,
                mx: 2,
                background: '#F5F5F5',
                borderRadius: 2,
                pl: 2,
              }}
            >
              <ConnectedTextField
                name="message"
                placeholder="Type your message"
                variant="standard"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  sx: { fontSize: 15, py: 1 },
                }}
                size="small"
                rows={2}
                multiline
              />
            </Paper>
            <IconButton
              size="large"
              sx={{ color: '#1976d2', ml: 1 }}
              type="submit"
              disabled={isSubmitting || loading || !values.message.trim()}
            >
              <SendIcon />
            </IconButton>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default SmsChatInput;
